import swal from '@sweetalert/with-react';

const CONFIRM_BUTTON_CLASS = 'btn-alert btn-alert-confirm-onboarding';

function showBlockingAlert({ title, text }) {
  return swal({
    title,
    text,
    buttons: {
      confirm: {
        text: 'Continuar',
        value: true,
        visible: true,
        className: CONFIRM_BUTTON_CLASS
      }
    },
    closeOnClickOutside: false,
    closeOnEsc: false
  });
}

export function showTimeOverAlert() {
  return showBlockingAlert({
    title: 'Ops, acabou o tempo.',
    text:
      'Infelizmente você não terminou a avaliação antes do tempo, clique abaixo para fechar a avaliação.'
  });
}

export function showNotReleasedAlert() {
  return showBlockingAlert({
    title: 'Prova ainda não liberada',
    text:
      'O aplicador ainda não liberou a sua prova. Aguarde na sala de espera.'
  });
}
